import { render, staticRenderFns } from "./delete-account.vue?vue&type=template&id=069e96e0"
import script from "./delete-account.vue?vue&type=script&lang=js"
export * from "./delete-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports